/**
 * Created by Ning Jiang on 10/26/2018.
 */

require("pixi-particles");

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";

export class CoinsFountain extends BaseView {

    private readonly _screenHeightRange: [number, number] = [720, 1760];
    private readonly _startSpeedRange: [number, number] = [650, 950];
    private readonly _startConfig: any = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 1,
            "end": 1,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 700,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1500
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 0,
            "max": 360
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 1,
            "max": 1
        },
        "blendMode": "normal",
        "frequency": 0.02,
        "emitterLifetime": -1,
        "maxParticles": 200,
        "pos": {
            "x": GameConfig.instance.GAME_WIDTH / 2,
            "y" : ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT/2,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -5,
            "y": 0,
            "w": 10,
            "h": 1
        }
    };
    private readonly _twinkleConfigRight: any = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.7,
            "end": 1,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 0,
            "end": 0,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 0,
            "max": 0
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 1,
            "max": 1
        },
        "blendMode": "normal",
        "frequency": 0.02,
        "emitterLifetime": -1,
        "maxParticles": 5,
        "pos": {
            "x": ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH,
            "y": 160,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x":80,
            "y": 0,
            "w": 300,
            "h":this._screenHeightRange[0]
        }
    };

    private readonly _twinkleConfigLeft: any = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.7,
            "end": 1,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 0,
            "end": 0,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 0,
            "max": 0
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 1,
            "max": 1
        },
        "blendMode": "normal",
        "frequency": 0.01,
        "emitterLifetime": -1,
        "maxParticles": 5,
        "pos": {
            "x": 0,
            "y": 20,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -330,
            "y": 0,
            "w": 260,
            "h":this._screenHeightRange[0]
        }
    };

    private readonly _coinsConfigs:any[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.3,
                "end" : .5,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 700,
                "end" : 350,
                "minimumSpeedMultiplier" : 2
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 235,
                "max" : 310
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 10,
                "max" : 70
            },
            "lifetime" : {
                "min" : 2,
                "max" : 2
            },
            "blendMode" : "normal",
            "frequency" : 0.06,
            "emitterLifetime" : -1,
            "maxParticles" : 50,
            "pos" : {
                "x" : GameConfig.instance.GAME_WIDTH / 2,
                "y" : ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT/2,
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -5,
                "y" : 0,
                "w" : 10,
                "h" : 1
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.7,
                "end" : 1,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 700,
                "end" : 350,
                "minimumSpeedMultiplier" : 2
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 235,
                "max" : 310
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 20,
                "max" : 40
            },
            "lifetime" : {
                "min" : 2,
                "max" : 2
            },
            "blendMode" : "normal",
            "frequency" : 0.06,
            "emitterLifetime" : -1,
            "maxParticles" : 200,
            "pos" : {
                "x" : GameConfig.instance.GAME_WIDTH / 2,
                "y" : ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT/2,
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -5,
                "y" : 0,
                "w" : 10,
                "h" : 1
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.7,
                "end" : 1,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 700,
                "end" : 350,
                "minimumSpeedMultiplier" : 2
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 235,
                "max" : 310
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 20,
                "max" : 40
            },
            "lifetime" : {
                "min" : 2,
                "max" : 2
            },
            "blendMode" : "normal",
            "frequency" : 0.1,
            "emitterLifetime" : -1,
            "maxParticles" : 200,
            "pos" : {
                "x" : GameConfig.instance.GAME_WIDTH / 2,
                "y" : ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT/2,
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -5,
                "y" : 0,
                "w" : 10,
                "h" : 1
            }
        }
    ];

    private _coinsEmitters: Emitter[];
    private _starEmitter: Emitter;
    private _twinkleEmitterLeft: Emitter;
    private _twinkleEmitterRight: Emitter;
    private _layer: ScalableLayer;

    private _isPlaying: boolean = false;

    constructor(layer: ScalableLayer) {
        super();
        this._layer = layer;
    }

    protected initAnimations(): void {
        let backGroundLayer = StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.BACKGROUND.name);
        this._coinsEmitters = [];
        this._coinsConfigs.forEach((config:any, level:number) => {
            const emitter:Emitter = new Emitter(this._layer, [{
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures(`bigWinCoin${level}`)
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmitters.push(emitter);
        });


        this._starEmitter = new Emitter(this._layer, [{
            framerate: 30,
            loop: true,
            hasLoaded: true,
            textures: GameResources.getTextures("winStar")
        }], this._startConfig);
        this._starEmitter.particleConstructor = AnimatedParticle;
        ParticlesManager.addEmitter(this._starEmitter, false);
        this._twinkleEmitterLeft = new Emitter(backGroundLayer, [{
            framerate: 30,
            loop: true,
            hasLoaded: true,
            textures: GameResources.getTextures("starAnim")
        }], this._twinkleConfigLeft);
        this._twinkleEmitterLeft.particleConstructor = AnimatedParticle;
        ParticlesManager.addEmitter(this._twinkleEmitterLeft, false);

        this._twinkleEmitterRight = new Emitter(backGroundLayer, [{
            framerate: 30,
            loop: true,
            hasLoaded: true,
            textures: GameResources.getTextures("starAnim")
        }], this._twinkleConfigRight);
        this._twinkleEmitterRight.particleConstructor = AnimatedParticle;
        ParticlesManager.addEmitter(this._twinkleEmitterRight, false);

    }

    public startFountain(playLevel: number): void {
        if (!this._isPlaying) {
            this._twinkleEmitterRight.emit = true;
            this._twinkleEmitterLeft.emit = true;
            this._starEmitter.emit = true;
        }
        this._isPlaying = true;
        if (this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        this._coinsEmitters.forEach((emitter: Emitter, level: number) => {
            if (level <= playLevel) {
                emitter.emit = true;
            }
        });

    }

    public stopFountain(): void {
        this._isPlaying = false;
        this._coinsEmitters.forEach((emitter: Emitter) => {
            emitter.emit = false;
        });
        this._twinkleEmitterRight.emit = false;
        this._twinkleEmitterLeft.emit = false;
        this._starEmitter.emit = false;
    }

    protected onResize(resizeData: IResizeData): void {
        this._resizeData = resizeData;

        if (!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }
        //this._currentHeight =0;
        this._isResizeDirty = false;
        let screenHeight: number = Math.round(resizeData.height / this._layer.scale.y);
        screenHeight = Math.max(this._screenHeightRange[0], Math.min(screenHeight, this._screenHeightRange[1]));
        //this._currentHeight = screenHeight;
        const startSpeed: number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
        const y: number = Math.round((resizeData.height - this._layer.y) / this._layer.scale.y) + 40;
        this._coinsEmitters.forEach((emitter: Emitter, level: number) => {
            const levelSpeed: number = startSpeed * (1 + 0.05 * level);
            emitter.cleanup();
            //emitter.startSpeed = levelSpeed;
            //emitter.endSpeed = levelSpeed;
            //emitter.spawnPos.y = y;
        });
        //this._starEmitter.spawnPos.y = y;
    }
}